import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-affiliates-configuration',
  templateUrl: './affiliates-configuration.component.html',
  styleUrls: ['./affiliates-configuration.component.scss']
})
export class AffiliatesConfigurationComponent {
  url = "";

  constructor(
    private router: Router
  ) {
    var parts = router.url.split("/");
    var position = parts[parts.length-1];
    if (position == 'convert'){
      this.url = 'convert';
    } else {
      this.url = 'admin';
    }
  }

}
